module.exports = __webpack_public_path__ + "static/alignment-5b7cc4bf60b062344eeb761cad8f17b4.png";